export default "__VITE_ASSET__tT0In8$m__"